<div class="dialog-container">
    <h4 mat-dialog-title class="dialog-title">{{data.title}}</h4>
    <div mat-dialog-content class="dialog-content text-muted">{{data.content}}</div>
    <div mat-dialog-actions class="dialog-actions mt-4 d-flex align-items-center justify-content-end">
        <button mat-button class="cancel-button" (click)="onNoClick()">{{data.cancelText}}</button>
        <div *ngIf="data?.status === 'approve'">
            <button mat-button class="btn btn-success yes-button" (click)="approveLoan()"
                *ngIf="!isLoading; else loadingTemplate1" cdkFocusInitial>{{data.confirmText}}</button>
        </div>
        <div *ngIf="data?.status === 'decline'">
            <button mat-button class="btn btn-danger yes-button" (click)="declineLoan()"
                *ngIf="!isLoading; else loadingTemplate2">
                {{data.confirmText}}
            </button>
        </div>
        <ng-template #loadingTemplate1>
            <button mat-button  class="btn btn-success yes-button" cdkFocusInitial disabled>
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            </button>
        </ng-template>
        <ng-template #loadingTemplate2>
            <button mat-button class="btn btn-danger yes-button" cdkFocusInitial disabled>
                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
            </button>
        </ng-template>
    </div>
</div>